// extracted by mini-css-extract-plugin
export default {"root":"nW8uZl","title":"N069tx","info":"vrLbRo","icon-button":"h7xevK","iconButton":"h7xevK","icon":"Tgp3fz"};